import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWebminComponent } from './simple-icons-webmin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWebminComponent ],
    exports:      [ SimpleIconsWebminComponent ],
    bootstrap:    []
})
export class SimpleIconsWebminModule {}
